export type VolumeProfileTabId = 'profile' | 'chart';
export type VolumeProfileViewMode = 'quote' | 'session' | 'total';
export type VolumeProfileSession = 'all' | 'premarket' | 'regular' | 'postmarket';
export type VolumeProfileRange = 'day' | '1h' | '5m' | '1m' | 'custom';
export type VolumeProfileOverlay = 'poc' | 'valueArea' | 'volumeProfile' | 'price' | 'vwap' | 'bidAsk';

export interface VolumeProfileState {
    tabId: VolumeProfileTabId;
    viewMode: VolumeProfileViewMode;
    session: VolumeProfileSession;
    range: VolumeProfileRange;
    overlays: Readonly<Record<VolumeProfileOverlay, boolean>>;
}

export interface VolumeProfileLevel {
    id: string;
    price: number;
    bid: number;
    mid: number;
    ask: number;
    premarket: number;
    regular: number;
    postmarket: number;
}

export interface VolumeProfileBarSegment {
    id: string;
    label: string;
    widthPct: number;
    className: string;
}

export interface VolumeProfileLevelView {
    id: string;
    price: number;
    priceFormatted: string;
    total: number;
    totalFormatted: string;
    segments: readonly VolumeProfileBarSegment[];
    isPoc: boolean;
    isVah: boolean;
    isVal: boolean;
}

export interface VolumeProfileStatRow {
    label: string;
    value: string;
    tone: 'default' | 'aqua' | 'jade' | 'ember' | 'honey' | 'purple';
    progressPct: number | null;
    progressClassName: string;
}

export interface VolumeProfileStatGroup {
    id: string;
    title: string;
    rows: readonly VolumeProfileStatRow[];
}

export interface VolumeProfileLegendItem {
    id: string;
    label: string;
    className: string;
}

export interface VolumeProfileChartBar {
    id: string;
    label: string;
    topPct: number;
    bodyTopPct: number;
    bodyHeightPct: number;
    volumePct: number;
    direction: 'up' | 'down';
}

export function createInitialVolumeProfileState(): VolumeProfileState {
    return {
        tabId: 'profile',
        viewMode: 'quote',
        session: 'all',
        range: 'day',
        overlays: {
            poc: true,
            valueArea: true,
            volumeProfile: true,
            price: true,
            vwap: true,
            bidAsk: true,
        },
    };
}
